<div [style]="style" class="tools" fxLayout="column" *ngIf="board">
  <div fxLayout="row">
    <div [style]="livesStyle">
      <app-snake *ngFor="let snake of lives" [snake]="snake" [bitSize]="width/40"></app-snake>
    </div>
    <button mat-button onclick="this.blur()" (click)="board.restart().catch()">
      <span class="material-icons notranslate">refresh</span>
    </button>
    <button mat-button onclick="this.blur()" (click)="board.pause()">
      <span class="material-icons notranslate">pause</span>
    </button>
    <div class="score" *ngIf="mySnake" [style]="scoreStyle">{{mySnake.score}}</div>
  </div>
  <mat-progress-bar *ngIf="mySnake" [style]="style" [value]="mySnake.ate/board.goal*100"></mat-progress-bar>
</div>
